module.exports = __webpack_public_path__ + "5a715350d4e729eda46ca6e9e41b5115.jpg";